import { gql } from '@apollo/client';

const query = gql`
  query searchProfileReviews($params: JSONObject) {
    searchProfileReviews(params: $params)
  }
`;

module.exports = query;
